import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEthers } from './useEthers';
import { useState, useEffect } from 'react';
/**
 * Returns a signer if an external wallet is connected.
 * @public
 * @returns a JsonRpcSigner if one is available in the provider. `undefined` otherwise.
 */
export function useSigner() {
  var _useEthers = useEthers(),
    library = _useEthers.library,
    account = _useEthers.account;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    signer = _useState2[0],
    setSigner = _useState2[1];
  useEffect(function () {
    if (library !== undefined && 'getSigner' in library && account !== undefined) setSigner(library.getSigner());else setSigner(undefined);
  }, [library, account]);
  return signer;
}